<div class="modal-header">
    <i class="far fa-calendar-alt fa-2x"></i>
    <h4 id="alert-modal-title" class="modal-title warnTittle pl-2">Calendario</h4>
    <button type="button" class="close" aria-label="Close" (click)="dismiss()">
        <span aria-hidden="true">&times;</span>
    </button>
</div>
<div class="text-center">
    <ngb-datepicker 
        #datePicker 
        [displayMonths]="2" 
        [startDate]="defaultDate"
        [minDate]="min" 
        [maxDate]="max" 
        [dayTemplate]="dayDatePicker"
        outsideDays="hidden"></ngb-datepicker>

    <ng-template #dayDatePicker let-date let-focused="focused">
      <span class="custom-day"
        [ngClass]=" { 'before': isBefore(date), 'focused': focused, 'range': isRange(date), 'faded': isHovered(date) || isInside(date), 'disabled': !isValidate(date) }"
        (click)="onClickDateSelection(date)"
        (dblclick)="onDbClickDateSelection(date)"
        (mouseenter)="hoveredDate = date"
        (mouseleave)="hoveredDate = null">
        {{ date.day }}
      </span>
    </ng-template>
</div>


